export default "__VITE_ASSET__a39607b3__"